<template>
  <form @submit.prevent>
    <header class="flex items-center md:mb-4.5 md:px-0">
      <UiTitle :severity="isMdAndUp ? 'h3' : 'h2'"> Выбрать город </UiTitle>
      <UiButton
        v-if="isMdAndUp"
        size="small"
        severity="quaternary"
        class="ml-auto flex size-7 min-w-7 items-center justify-center"
        @click="emit('close')"
      >
        <UiIcon name="x-mark" class="size-4.5" />
      </UiButton>
    </header>
    <LocationList
      v-show="pinnedLocations?.length"
      :value="pinnedLocations"
      :current-location="currentLocation"
      class="p-0 pb-1"
      type="big"
      @click="emit('chooseLocation', $event)"
    />
    <UiInput
      :model-value="modelValue"
      type="search"
      severity="primary"
      maxlength="50"
      class="rounded-md pr-10"
      placeholder="найти другой город"
      @update:model-value="emit('update:modelValue', $event)"
    >
      <template #append>
        <UiIcon
          name="magnifying-glass"
          class="absolute right-4 top-0 size-3 h-full text-icon-primary"
        />
      </template>
    </UiInput>
  </form>
</template>

<script lang="ts" setup>
import { LocationList, type Location } from '@/5_entities/Location'
import { useBreakpoint } from '@/6_shared/lib'
import { UiButton, UiIcon, UiInput, UiTitle } from '@/6_shared/ui'

type PropType = {
  modelValue: string
  isPage: boolean
  pinnedLocations: Location[]
  currentLocation?: Location
}

type EmitType = {
  (e: 'update:modelValue', value: string): void
  (e: 'close'): void
  (e: 'chooseLocation', value: Location): void
}

defineProps<PropType>()

const emit = defineEmits<EmitType>()
const {
  md: [isMdAndUp]
} = useBreakpoint()
</script>
